import { Modal } from './Modal';
import type { ModalProps, ConstructedButton } from './Modal/ModalProps.interface';

interface AlertProps extends ModalProps {
  readonly buttonLabel?: string;
}

export class Alert {
  static show({
    buttons = [Modal.BUTTONS().OK],
    buttonLabel = null,
    ...modalProps
  }: AlertProps) {
    if (!buttonLabel) {
      Modal.show({
        ...modalProps,
        buttons,
      });
    } else {
      const buttonArray: ConstructedButton[] = [{
        label: buttonLabel,
        onClick: Modal.hide,
        color: 'primary',
        variant: 'contained',
      }];

      Modal.show({
        ...modalProps,
        buttons: buttonArray,
      });
    }
  }
}
